import getParent, { getParentAttribute } from "../../utils/getParent";
import reporter from "../report/reporter";
import { getPage, getSearch } from "../shared/global";
import { getAttribute } from "./get";
/**
 * 专题点击
 * @param {Element} targetNode
 */
export function topic_click(targetNode) {
  const page = getPage();

  const trackData = {
    event_id: 35004,
    event: "topic_click",
    topic_id:
      targetNode.getAttribute("data-topic-id") ||
      getParentAttribute(targetNode, "data-topic-id"),
    topic_title:
      targetNode.getAttribute("data-topic-title") ||
      getParentAttribute(targetNode, "data-topic-title"),
    ...page,
  };

  const { page_nm, sub_page_nm } = page;
  var sourceNode =
    (targetNode.hasAttribute("data-content-source") && targetNode) ||
    getParent(targetNode, "[data-content-source]");

  if (sourceNode) {
    const topic_type = getAttribute(targetNode, "data-topic-type");
    if (topic_type) {
      trackData.topic_type = topic_type;
    }
    trackData.topic_source = `${page_nm}_${
      sub_page_nm || ""
    }_${sourceNode.getAttribute("data-content-source")}`;
  } else {
    trackData.topic_source = `${page_nm}_${sub_page_nm || ""}`;
  }
  if (page_nm === "搜索结果页") {
    const input = document.getElementById("hb_search_input");
    trackData.search_word = input?.value;
    trackData.search_word_type = getSearch().search_word_type;
    trackData.filter_ids = getSearch().filter_ids || [];
  }

  reporter(trackData);
}
